import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { useIsInventoryEnabled } from '../hooks/inventory';
import { useNumberOfShipFroms } from '../hooks/shipFrom';
import BulkUpdateShipDate from './buttons/ship-date';
import BulkUpdateShipFrom from './buttons/ship-from';
import BulkUpdateDeductInventory from './buttons/deduct-inventory';
import BulkUpdateCarrier from './buttons/carrier';
import BulkUpdateNotifyCustomer from './buttons/notify-customer';
import BulkUpdateNotifyMarketplace from './buttons/notify-marketplace';
import BulkRemove from './buttons/remove';

import style from './style.module.less';

const MarkAsShippedBulkUpdate = ({ shouldForceShipFrom = false }) => {
  const isInventoryEnabled = useIsInventoryEnabled();
  const numberOfShipFroms = useNumberOfShipFroms();

  const shouldShowShipFrom = (isInventoryEnabled && numberOfShipFroms > 1) || shouldForceShipFrom;

  return (
    <div className={style['bulk-update-wrapper']}>
      <FormattedMessage
        defaultMessage='<b>Bulk Update</b>:'
        description='markAsShippedmodal.bulkUpdate'
        id='oqtRFj'
        values={{ b: (chunks) => <b>{chunks}</b> }}
      />
      <BulkUpdateShipDate />
      {shouldShowShipFrom && <BulkUpdateShipFrom shouldForceShipFrom={shouldForceShipFrom} />}
      {isInventoryEnabled && <BulkUpdateDeductInventory />}
      <BulkUpdateCarrier />
      <BulkUpdateNotifyCustomer />
      <BulkUpdateNotifyMarketplace />
      <BulkRemove />
    </div>
  );
};

MarkAsShippedBulkUpdate.propTypes = {
  shouldForceShipFrom: PropTypes.bool,
};

export default MarkAsShippedBulkUpdate;
